<template>
    <div class="site-header">
        <div class="left" @click="handleHome">
            <img
                class="logo"
                src="@/assets/imgs/logo-new.png"
                alt="梦饷云"
                srcset=""
            />

            <div class="line"></div>
            <div class="sub">
                新电商基础设施提供者
            </div>
        </div>
        <div class="right">
            <div class="login text" @click="handleLogin">
                登录
            </div>

            <div class="register text" @click="handleRegister">
                注册
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SiteHeader',
    data() {
        return {};
    },
    methods: {
        handleHome() {
            this.$router.push({
                path: '/'
            });
        },
        handleLogin() {
            this.$router.push({
                path: '/login'
            });
        },
        handleRegister() {
            this.$router.push({
                path: '/register'
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.site-header {
    padding: 0 100px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: linear-gradient(267deg, #ff7f83 0%, #fe3f45 100%);
    box-shadow: 0px 2px 4px 0px rgba(212, 212, 212, 0.5);

    .left {
        display: flex;
        align-items: center;
        .logo {
            width: 115px;
            height: 28px;
            vertical-align: top;
        }

        .line {
            margin: 0 14px;
            width: 1px;
            height: 16px;
            background: #ffffff;
        }
        .sub {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #f2f2f2;
            line-height: 22px;
        }
    }
    .right {
        display: flex;
        align-items: center;
        .login {
            cursor: pointer;
        }
        .text {
            font-size: 16px;
            font-weight: 400;
            color: #ffffff;
            line-height: 22px;
        }

        .register {
            margin: 0 24px;
            padding: 0 20px;
            height: 42px;
            line-height: 42px;
            text-align: center;
            background-color: #ffffff;
            color: #fe3f45;
            border-radius: 3px;
            cursor: pointer;

            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ff4541;
        }
    }
}
</style>
